import { TranslationBuilder } from '~/code/components/Translation'

export default TranslationBuilder.create<{
    iAgreeToShareWithClickToPay: (cardBrand: string) => string
    learnMore: string
    next: string,
    pay: string,
    submit: string
}>()
